import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/brand.css';
// Last, so where a token name exists in both systems Variant C's value wins.
// The only two that did — the app's own --radius-sm and --danger-bg — were
// renamed with a -legacy suffix instead, so nothing here is a silent override.
import './styles/variant-c/tokens.css';
import './styles/variant-c/canvas.css';
import './styles/variant-c/primitives.css';
import './styles/variant-c/shell.css';
import './styles/variant-c/overlays.css';
import './styles/variant-c/pages.css';
// Last of the generated files: a media rule must win over the base rule it
// narrows, and every breakpoint in the design lives in this one file.
import './styles/variant-c/responsive.css';
// Deliberate divergences from the demo, each with its reason. Last, because
// each one exists to beat the generated rule it names.
import './styles/variant-c/overrides.css';
import './i18n';
import App from './App';
import CookieConsent from './components/CookieConsent';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    {/* Mounted once at the root — outside every page container — so the
        consent banner overlays all views (landing, demo, account,
        onboarding) and never interferes with page-local effects such as the
        landing page's animated-blob height calc. */}
    <CookieConsent />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PRODUCTION ONLY, and that is not a detail.
//
// The service worker caches everything under /static/ cache-first, forever,
// which is safe exactly because a production filename is content-hashed: the
// name identifies the bytes, so a cached entry can never be stale. In
// DEVELOPMENT that is false — webpack-dev-server emits unhashed names like
// `src_pages_SimulationPage_js.chunk.js` — so the first version of a chunk a
// dev browser ever saw would be served for ever, and every later edit to it
// would be invisible or, once module ids moved underneath it, would throw on
// load.
//
// That was survivable while the dev build was one bundle. H3's code splitting
// turned it into ~25 separately-cached, separately-staleable files, and it
// started presenting as "the Simulation page is broken" — a cached chunk from
// an older build, failing against a newer runtime.
//
// A browser already in that state cannot be rescued from here — the stale thing
// it is serving IS this file, so nothing written below would ever run. The
// cleanup therefore lives in `public/service-worker.js`, which the browser
// re-fetches and byte-compares on navigation: on a local host that script now
// deletes its caches and unregisters itself. The guard below only stops a new
// registration from being created.
//
// This condition MUST stay in step with `isDevHost` in public/service-worker.js.
// The worker refuses to run on a local host and unregisters itself there; if
// this file registered it again afterwards the two would fight — register,
// self-destruct, reload, register — and a production build served from
// localhost would sit in a reload loop.
const isLocalHost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)
  || window.location.hostname.endsWith('.local');

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && !isLocalHost) {
  window.addEventListener('load', () => {
    // Registration is best-effort: it fails on any host that does not serve
    // /service-worker.js from the root, and an unhandled rejection there logs
    // a page error over something the app does not need to run.
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}